import { getTemplate } from "../handlebars";
import $ from 'jquery';

export default class ProductDetailPage {

    /**
     * Adds the product group data to the page by sending a GET request to the server to retrieve the serialised data
     * for the product group.
     */
    getDetail() {
        $.ajax({
            url: pageData.productDetailURL,
            type: "GET",
            success: function (data) {
                let description = data.description
                if (!description){
                    description = ''
                }
                let imageURL = data.image;
                if (!imageURL) {
                    imageURL = pageData.imageURL;
                }
                document.getElementById('product-name').innerHTML = data.name
                document.getElementById('product-image').setAttribute('src', imageURL)
                document.getElementById('product-description').innerHTML = description

                data.datasets.forEach(function (dataset) {
                    let li = document.createElement("li")
                    li.className = 'list-group-item'
                    li.innerHTML = dataset
                    document.getElementById("dataset-list").appendChild(li)
                })
            }.bind(this),
        });
    }

    /**
     * Subscribes the user to the product group subscription by sending a POST request to the server.
     */
    subscribeUser() {
        $.ajax({
            url: pageData.subscribeURL,
            type: "POST",
            data: {
                csrfmiddlewaretoken: pageData.csrfToken
            },
            success: function () {
                this.showHideElements(true);
                toastr.success('You have been subscribed to this product group.')
            }.bind(this),
        });
    }

    /**
     * Unsubscribes the user from the product group subscription by sending a POST request to the server.
     */
    unsubscribeUser() {
        $.ajax({
            url: pageData.unsubscribeURL,
            type: "POST",
            data: {
                csrfmiddlewaretoken: pageData.csrfToken
            },
            success: function () {
                this.showHideElements(false);
                toastr.success('You have been unsubscribed from this product group.')
            }.bind(this),
        });
    }

    /**
     * Calls subscribeUser when clicking on the 'Subscribe' button
     */
    handleSubscribeBtnClick(){
        $(document).on(
            "click",
            "#subscribe-btn",
            function () {
                this.subscribeUser();
            }.bind(this)
        );
    }

    /**
     * Calls unsubscribeUser when clicking on the 'Unsubscribe' button
     */
    handleUnsubscribeBtnClick(){
        $(document).on(
            "click",
            "#unsubscribe-btn",
            function () {
                this.unsubscribeUser();
            }.bind(this)
        );
    }

    /**
     * Shows and hides the subscribe button, unsubscribe button, and unsubscribed alert according to the user's
     * subscription status.
     * @param {boolean} isSubscribed - true if the user is subscribed, else false
     */
    showHideElements(isSubscribed){
        if (isSubscribed){
            $('#unsubscribe-btn').show();
            $('#subscribe-btn').hide();
            $('#unsubscribed-alert').hide();
        }
        else {
            $('#subscribe-btn').show();
            $('#unsubscribe-btn').hide();
            $('#unsubscribed-alert').show();
        }
    }


    ready() {
        for (const [key, value] of Object.entries(pageData.partials)) {
            getTemplate(value, key);
        }
        this.getDetail();
        let canSubscribe = pageData.canSubscribe === 'True';
        let isSubscribed = pageData.isSubscribed === 'True';
        if (canSubscribe){
            this.showHideElements(isSubscribed);
        }
        this.handleSubscribeBtnClick();
        this.handleUnsubscribeBtnClick();
    };
}
